
export var accelerationProfileData = {
  "acceleration" : [
    { "acceleration": 0.5, "duration": 800000 },
    { "acceleration": 1.0, "duration": 900000 },
    { "acceleration": 1.5, "duration": 500000 },
    { "acceleration": 2.0, "duration": 200000 },
    { "acceleration": 2.5, "duration": 110000 },
    { "acceleration": 3.0, "duration": 80000 },
    { "acceleration": 3.5, "duration": 50000 },
    { "acceleration": 4.0, "duration": 20000 },
    { "acceleration": 4.5, "duration": 10000 },
    { "acceleration": 5.0, "duration": 5000 },
    { "acceleration": 5.5, "duration": 3000 },
    { "acceleration": 6.0, "duration": 1000 },
    { "acceleration": 6.5, "duration": 800 },
    { "acceleration": 7.0, "duration": 400 },
    { "acceleration": 7.5, "duration": 10000 },
    { "acceleration": 8.0, "duration": 2000 },
    { "acceleration": 8.5, "duration": 1000 },
    { "acceleration": 9.0, "duration": 500 },
    { "acceleration": 9.5, "duration": 100 },
    { "acceleration": 10, "duration": 50 }
  ],
  "deceleration" : [
    { "acceleration": -10, "duration": 10 },
    { "acceleration": -9.5, "duration": 50 },
    { "acceleration": -9.0, "duration": 100 },
    { "acceleration": -8.5, "duration": 500 },
    { "acceleration": -8.0, "duration": 1000 },
    { "acceleration": -7.5, "duration": 2000 },
    { "acceleration": -7.0, "duration": 10000 },
    { "acceleration": -6.5, "duration": 40000 },
    { "acceleration": -6.0, "duration": 80000 },
    { "acceleration": -5.5, "duration": 100000 },
    { "acceleration": -5.0, "duration": 300000 },
    { "acceleration": -4.5, "duration": 500000 },
    { "acceleration": -4.0, "duration": 1000000 },
    { "acceleration": -3.5, "duration": 2000000 },
    { "acceleration": -3.0, "duration": 5000000 },
    { "acceleration": -2.5, "duration": 8000000 },
    { "acceleration": -2.0, "duration": 11000000 },
    { "acceleration": -1.5, "duration": 20000000 },
    { "acceleration": -1.0, "duration": 50000000 },
    { "acceleration": -0.5, "duration": 90000000 }
  ],
}

export var brakingBehaviorData = [
    { "distance": 20, "speed": 46 },
    { "distance": 120, "speed": 45 },
    { "distance": 220, "speed": 49 },
    { "distance": 320, "speed": 51 },
    { "distance": 420, "speed": 55 },
    { "distance": 520, "speed": 54 },
    { "distance": 620, "speed": 56 },
    { "distance": 720, "speed": 58 },
    { "distance": 820, "speed": 62 },
    { "distance": 920, "speed": 60 },
    { "distance": 1020, "speed": 58 },
    { "distance": 1120, "speed": 56 },
    { "distance": 1220, "speed": 60 },
    { "distance": 1320, "speed": 60 },
    { "distance": 1420, "speed": 58 },
    { "distance": 1520, "speed": 55 },
    { "distance": 1620, "speed": 53 },
    { "distance": 1720, "speed": 55 },
    { "distance": 1820, "speed": 57 },
    { "distance": 1920, "speed": 59 },
    { "distance": 2020, "speed": 60 },
    { "distance": 2120, "speed": 57 },
    { "distance": 2220, "speed": 54 },
    { "distance": 2320, "speed": 55 },
    { "distance": 2420, "speed": 58 },
    { "distance": 2520, "speed": 60 },
    { "distance": 2620, "speed": 58 },
    { "distance": 2720, "speed": 56 },
    { "distance": 2820, "speed": 53 },
    { "distance": 2920, "speed": 51 },
    { "distance": 3020, "speed": 53 },
    { "distance": 3120, "speed": 55 },
    { "distance": 3220, "speed": 57 },
    { "distance": 3320, "speed": 59 },
    { "distance": 3420, "speed": 58 },
    { "distance": 3520, "speed": 56 },
    { "distance": 3620, "speed": 54 },
    { "distance": 3720, "speed": 52 },
    { "distance": 3820, "speed": 50 },
    { "distance": 3920, "speed": 49 },
    { "distance": 4020, "speed": 47 },
    { "distance": 4120, "speed": 45 },
    { "distance": 4220, "speed": 44 },
    { "distance": 4320, "speed": 42 },
    { "distance": 4420, "speed": 41 },
    { "distance": 4520, "speed": 43 },
    { "distance": 4620, "speed": 45 },
    { "distance": 4720, "speed": 47 },
    { "distance": 4820, "speed": 49 },
    { "distance": 4920, "speed": 50 },
    { "distance": 5020, "speed": 48 },
    { "distance": 5120, "speed": 46 },
    { "distance": 5220, "speed": 44 },
    { "distance": 5320, "speed": 42 },
    { "distance": 5420, "speed": 40 },
    { "distance": 5520, "speed": 39 },
    { "distance": 5620, "speed": 37 },
    { "distance": 5720, "speed": 35 },
    { "distance": 5820, "speed": 31 },
    { "distance": 5920, "speed": 28 },
    { "distance": 6020, "speed": 31 },
    { "distance": 6120, "speed": 34 },
    { "distance": 6220, "speed": 32 },
    { "distance": 6320, "speed": 31 },
    { "distance": 6420, "speed": 34 },
    { "distance": 6520, "speed": 42 },
    { "distance": 6620, "speed": 43 },
    { "distance": 6720, "speed": 35 }
  ]

const scorecardDetails = {
  "organizationName": "NeoTreks, Inc.",
  "terminalName": "La Guardia Terminal",
  "driverName": "tomas@neotreks.com",
  "driverFirstName": "Tomas",
  "driverLastName": "Knor",
  "startTimeUtc": "2024-04-01T13:00:00.000+00:00",
  "endTimeUtc": "2024-04-01T17:59:59.000+00:00",
  "simplifiedPolyLine": {
    "type": "LineString",
    "coordinates": [
      [
        18.3507149,
        49.6783781
      ],
      [
        18.5544382,
        49.6777146
      ],
      [
        18.5160664,
        49.6887687
      ],
      [
        18.4599882,
        49.6674347
      ],
      [
        18.3382837,
        49.6770832
      ],
      [
        18.3232733,
        49.6932862
      ],
      [
        18.3413857,
        49.6739347
      ],
      [
        18.5534471,
        49.6770011
      ]
    ]
  },
  "sessionKey": "68879810-5a66-4db5-bef7-8ef63633f396",
  "minLat": 49.6672248,
  "maxLat": 49.693313,
  "minLon": 18.3232631,
  "maxLon": 18.5544613,
  "distance": 26.90565599199331,
  "distanceUnit": "miles"
};

const scorecardEvents = [
  {
    "id": "83962b43-1157-452c-a44c-412dfc958cf7",
    "type": "overspeed",
    "timestamp": "2024-04-01T16:16:17+00:00",
    "distance": 12.45325633883644,
    "distanceUnit": "mile",
    "metadata": {
      "id": 3732670,
      "driverId": 2,
      "minLat": 33.288235,
      "maxLat": 33.28843166666666,
      "minLon": -111.75760999999999,
      "maxLon": -111.75739666666665,
      "timeStart": "2024-04-01T16:16:17+00:00",
      "timeEnd": "2024-04-01T16:16:18+00:00",
      "sessionKey": "68879810-5a66-4db5-bef7-8ef63633f396",
      "alertType": 4,
      "speed": 26.009428024291992,
      "speedLimit": 14.889986562243935,
      "startLon": -111.75739666666665,
      "startLat": 33.28843166666666,
      "endLon": -111.75760999999999,
      "endLat": 33.288235
    }
  },
  {
    "id": "e904839c-40b4-4801-b379-be8d44fbad94",
    "type": "overspeed",
    "timestamp": "2024-04-01T16:23:11+00:00",
    "distance": 13.45325633883644,
    "distanceUnit": "mile",
    "metadata": {
      "id": 3732671,
      "driverId": 2,
      "minLat": 33.291855000000005,
      "maxLat": 33.29228666666667,
      "minLon": -111.89231333333333,
      "maxLon": -111.88931666666667,
      "timeStart": "2024-04-01T16:23:11+00:00",
      "timeEnd": "2024-04-01T16:23:20+00:00",
      "sessionKey": "68879810-5a66-4db5-bef7-8ef63633f396",
      "alertType": 2,
      "speed": 31.094369888305664,
      "speedLimit": 21.492880595573904,
      "startLon": -111.88931666666667,
      "startLat": 33.291855000000005,
      "endLon": -111.89231333333333,
      "endLat": 33.29228666666667
    }
  },
  {
    "id": "c1924048-3121-4709-bdc0-689b844c0229",
    "type": "hardbrake",
    "timestamp": "2024-04-01T17:54:32+00:00",
    "distance": 14.595273601936,
    "distanceUnit": "mile",
    "metadata": {
      "timeStart": "2024-04-01T17:54:32+00:00",
      "timeEnd": "2024-04-01T17:54:35+00:00",
      "maxAcc": -6.282051975765229,
      "maxSpeed": 47.397491560325626,
      "minSpeed": 30.08154769239426
    }
  },
  {
    "id": "eeb66597-d532-4f0e-9a20-41b5f83829d6",
    "type": "hardacc",
    "timestamp": "2024-04-01T17:56:57+00:00",
    "distance": 15.701314323696,
    "distanceUnit": "mile",
    "metadata": {
      "timeStart": "2024-04-01T17:56:57+00:00",
      "timeEnd": "2024-04-01T17:57:00+00:00",
      "maxAcc": 6.711538926219941,
      "maxSpeed": 35.20068424125672,
      "minSpeed": 22.600870776386262
    }
  },
];

const scorecardMapFeatures = [
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.75760999999999, 33.288235]
    },
    'properties': {
      'id': '83962b43-1157-452c-a44c-412dfc958cf7',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.76760999999999, 33.288235]
    },
    'properties': {
      'id': 'UUID-placeholder-1',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.77760999999999, 33.288235]
    },
    'properties': {
      'id': 'UUID-placeholder-2',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.78760999999999, 33.288235]
    },
    'properties': {
      'id': 'UUID-placeholder-3',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.86231333333333, 33.291855000000005]
    },
    'properties': {
      'id': 'UUID-placeholder-4',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.87231333333333, 33.291855000000005]
    },
    'properties': {
      'id': 'UUID-placeholder-5',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.88231333333333, 33.291855000000005]
    },
    'properties': {
      'id': 'UUID-placeholder-6',
      'type': 'location',
      'status': 'normal'
    }
  },
  {
    'type': 'Feature',
    'geometry': {
      'type': 'Point',
      'coordinates': [-111.89231333333333, 33.291855000000005]
    },
    'properties': {
      'id': 'e904839c-40b4-4801-b379-be8d44fbad94',
      'type': 'location',
      'status': 'normal'
    }
  }
];

export var scorecardDataIdeal = {
  "features": scorecardMapFeatures,
  "events": scorecardEvents,
  "details": scorecardDetails
}

export var scorecardData = {
  "features": {
    "features": scorecardMapFeatures
  },
  "events": scorecardEvents,
  "details": scorecardDetails
}
